/**
 * Custom Hallatech header: layout metrics for overlay hero.
 * Scroll-up sticky state is handled by header.js — do not duplicate it here.
 */
function initHallatechHeader() {
  const header = document.getElementById('header-component');
  const bar = header?.querySelector('.header__columns--hallatech');
  if (!header || !bar) return;

  let metricsRaf = null;

  const updateMetrics = () => {
    metricsRaf = null;

    const logo = bar.querySelector('.header-logo');
    const barRect = bar.getBoundingClientRect();
    let visualBottom = barRect.bottom;

    if (logo) {
      visualBottom = Math.max(visualBottom, logo.getBoundingClientRect().bottom);
    }

    const headerSection = header.closest('.header-section');
    const sectionTop = headerSection?.getBoundingClientRect().top ?? 0;
    const layoutHeight = header.offsetHeight;
    const visualHeight = Math.max(Math.ceil(visualBottom - sectionTop), layoutHeight);

    document.body.style.setProperty('--hallatech-header-visual-height', `${visualHeight}px`);
  };

  const scheduleMetrics = () => {
    if (metricsRaf !== null) return;
    metricsRaf = requestAnimationFrame(updateMetrics);
  };

  const resizeObserver = new ResizeObserver(scheduleMetrics);

  resizeObserver.observe(header);
  resizeObserver.observe(bar);

  const logo = bar.querySelector('.header-logo');
  if (logo) resizeObserver.observe(logo);

  updateMetrics();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHallatechHeader);
} else {
  initHallatechHeader();
}
